import React from 'react';
import ReactTooltip from 'react-tooltip';

import Table from 'corp/components/UI/Table';
import TimeFormatter from 'corp/components/Format/TimeFormatter';
import BooleanFormatter from 'corp/components/Format/BooleanFormatter';
import ObjectIDFormatter from 'corp/components/Format/ObjectIDFormatter';
import TextFormatter from 'react-scale/corp/components/Format/TextFormatter';

const COLUMNS = [
  {
    accessor: 'createdAt',
    Header: 'Created At',
    width: 100,
    resizeable: true,
    filterable: false,
    sortable: true,
    Cell: TimeFormatter,
  },
  {
    accessor: 'updatedAt',
    Header: 'Updated At',
    width: 100,
    resizeable: true,
    filterable: false,
    sortable: true,
    Cell: TimeFormatter,
  },
  {
    accessor: 'auditTask',
    Header: 'Audit Task Id',
    width: 250,
    resizeable: true,
    filterable: false,
    sortable: false,
    Cell: ObjectIDFormatter,
  },
  {
    accessor: 'status',
    Header: 'Status',
    width: 100,
    resizeable: true,
    filterable: false,
    sortable: true,
    Cell: TextFormatter,
  },
  {
    accessor: 'isInternalAudit',
    Header: 'QIR?',
    width: 100,
    resizeable: true,
    filterable: false,
    sortable: true,
    Cell: BooleanFormatter,
  },
  {
    accessor: 'reasonForAudit',
    Header: 'Audit Reason',
    width: 100,
    resizeable: true,
    filterable: false,
    sortable: true,
    Cell: TextFormatter,
  },
];

const InternalAuditHistory = ({ audits = [] } = {}) => (
  <React.Fragment>
    <div className="customer-audit-history">
      <Table
        style={{
          width: 'auto',
          height: 'auto',
        }}
        minRows={1}
        showPagination={audits.length > 7}
        columns={COLUMNS}
        data={audits}
      />

      <ReactTooltip />
    </div>

    <style jsx>{`
      .ReactTable {
        width: auto;
      }
      .customer-audit-history {
        display: flex;
        flexdirection: column;
      }
    `}</style>
  </React.Fragment>
);

export default InternalAuditHistory;
